window.pw = window.pw || {};

(function (window) {

    "use strict";

    var o = window.pw;
    var $ = window.jQuery;

    o.doc('DataTable', '0.1.171000');

    o.dataTable = {

        initFilter: function (table) {

            var ui = table.tables().nodes().to$(),
                thead = ui.find('thead'),
                addFilters = [],
                filtersValues = ui.data('filterValues') || {filters: {}},
                json = table.ajax.json(),
                filterOptions = json.filterOptions,
                filterElements = null,
                m = this
            ;

            // console.log(json);

            thead.find('th').each(function (i) {

                var th = $(this),
                    columns = table.settings().init().columns,
                    column = columns[i];

                if (column) {
                    var filterName = column.data,
                        filterInputName = 'filter[' + filterName + ']',
                        datalistName = 'datalist2' + filterName;
                }

                // console.log(column);

                if (th.is('[data-filter]') && filterName) {

                    if (!th.hasClass('has-filter')) {

                        th.addClass('has-filter');
                        var filterType = th.attr('data-filter') || 'text';

                        switch (filterType.toLocaleLowerCase()) {
                            case 'select':
                                filterElements = m.f.newSelect({
                                    'name': filterInputName,
                                    'value': filtersValues.filters[filterName]
                                }, table);
                                break;
                            default:
                                filterElements = m.f.newInputText({
                                    'name': filterInputName,
                                    'value': filtersValues.filters[filterName],
                                    'list': datalistName
                                }, table);


                        }

                        addFilters.push(
                            $('<td class="filter ' + filterType + '"></td>')
                                .append(filterElements)
                                .append($('<span class="cleaner">✖</span>'))
                        );

                        // console.error('rysuje filtry ' +filterName);
                    }


                    var dataList = (filterElements && filterElements.length > 0)
                        ? filterElements[1]
                        : $('datalist#' + datalistName).html('');

                    var filterInput = (filterElements && filterElements.length > 0)
                        ? filterElements[0]
                        : $(filterInputName);

                    if (dataList && dataList.length) {

                        $.each(filterOptions[filterName], function () {
                            dataList.append('<option value="' + this + '">');
                            // console.log(dataList +' ' +this);
                        });

                    }

                    if (filterInput.is('select')) {
                        $.each(filterOptions[filterName], function (i) {
                            filterInput.append('<option value="' + i + '">' + this + '</option>');
                            // console.log(dataList +' ' +this);
                        });
                    }

                    filterInput.val(filterInput.data('filterValues'))

                } else {
                    if (!th.hasClass('has-filter')) {
                        th.addClass('has-filter');
                        addFilters.push($('<td>&nbsp;</td>'));
                    }
                }
            });

            if (addFilters.length) {
                thead.append($('<tr role="filter"></tr>').append(addFilters));
            }

        },

        getFiltersData: function (table) {
            var ui = table.tables().nodes().to$(),
                filtersValues = ui.data('filterValues') || {filters: {}};
            return filtersValues;
        },

        f: {
            newInputText: function (attributes, table) {
                attributes = $.extend(attributes, {
                    'class': 'table-col-filter text',
                    'type': 'text'
                });
                var value = attributes.value;
                return [
                    $('<input>').attr(attributes).data('table', table).data('setValue', value),
                    $('<datalist id="' + attributes.list + '"></datalist>')
                ];
            },
            newSelect: function (attributes, table) {
                attributes = $.extend(attributes, {
                    'class': 'table-col-filter select',
                    'type': 'text'
                });
                var value = attributes.value;
                return [
                    $('<select>').attr(attributes).data('table', table).data('setValue', value)
                ];
            }

        }

    };

    $(window.document)
        .on('updateFilter.pw.table', '.table-col-filter', function (e, idle) {

            var ui = $(this),
                tr = ui.parents('td').eq(0),
                table = ui.data('table'),
                uiTable = table.tables().nodes().to$(),
                filterSleep = uiTable.data('filterSleep'),
                filterValues = uiTable.data('filterValues') || {}
            ;

            idle = (idle) || 500;

            clearTimeout(filterSleep);

            filterValues[ui.attr('name')] = ui.val();

            if (ui.val()) {
                tr.addClass('active');
                ui.addClass('active');
            } else {
                tr.removeClass('active');
                ui.removeClass('active');
            }

            uiTable.data('filterValues', filterValues);

            if (idle >= 0) {
                filterSleep = setTimeout(function () {
                    table.draw();
                }, idle);
            }


            uiTable.data('filterSleep', filterSleep);

        })
        .on('keyup', '.table-col-filter.text', function (e) {

            $(this).trigger('updateFilter.pw.table', [-1]);

            if (e.keyCode == 13) {
                $(this).trigger('updateFilter.pw.table', [200]);
            }

        })
        .on('input', '.table-col-filter', function (e) {
            // $(this).trigger('change');
            $(this).trigger('updateFilter.pw.table', [200]);
        })
        .on('change', '.table-col-filter', function (e) {
            // $(this).trigger('updateFilter.pw.table', [200]);
        })
        .on('click', '[role="filter"] td .cleaner', function (e) {
            $(this).parent().find('input').val('').trigger('updateFilter.pw.table', [50]);

        })
    ;

})(window);